// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2350":"6c97b22086d25ecf","6084":"ca9e170591071e37","8010":"5efa1690f337da2c"}[chunkId] + ".css";
};